<template>
  <div class="grid grid-cols-3">
    <div>
      <div
        v-if="item.strategy_market === 'Equities'"
        :content="
          item.limit_type === 'PER_TRADE'
            ? 'Perda por operação'
            : 'Perda máxima diária'
        "
        v-tippy="{
          arrow: true,
          theme: item.max_daily_loss === 0 ? 'red' : 'green',
        }"
      >
        <p class="label_card" v-if="item.limit_type === 'PER_TRADE'">
          Perda/op.
        </p>
        <p class="label_card" v-else-if="item.limit_type === 'DAILY'">
          Perda máx.
        </p>
        <p
          class="text-ontick-red-600 dark:text-ontick-red-500 text-left text-xs font-medium sm:text-sm"
        >
          <span>
            {{ (item.max_loss * -1) | currency }}
          </span>
        </p>
      </div>
      <div v-else>
        <p class="label_card">Perda máx.</p>
        <div
          class="text-ontick-red-600 dark:text-ontick-red-500 text-left text-xs font-medium sm:text-sm"
        >
          <div
            class="flex items-center justify-start space-x-1"
            v-if="item.max_daily_loss != 0"
          >
            <span
              class="whitespace-nowrap"
              :content="
                item.max_daily_loss === 0
                  ? 'Estratégia sem limite de perda configurado'
                  : 'Perda máxima diária'
              "
              v-tippy="{
                arrow: true,
                theme: item.max_daily_loss === 0 ? 'red' : 'green',
              }"
            >
              {{ item.max_daily_loss | currency }}
            </span>
            <div
              class="scale-90 transform"
              content="<p>É possível que a perda máxima diária seja maior que a informada. <a class='underline' target='_blank' href='https://ajuda.ontick.com.br/support/solutions/articles/151000020817-quando-a-perda-m%C3%A1xima-de-uma-estrat%C3%A9gia-pode-ultrapassar-o-previsto-'>Saiba mais</a></p>"
              v-tippy="{
                arrow: true,
                theme: 'green',
                interactive: true,
              }"
            >
              <i v-html="$icons.info" class="text-gray-400"></i>
            </div>
          </div>

          <span
            v-else
            class="flex items-center space-x-2"
            :content="
              item.max_daily_loss === 0
                ? 'Estratégia sem limite de perda configurado'
                : 'Perda máxima diária'
            "
            v-tippy="{
              arrow: true,
              theme: item.max_daily_loss === 0 ? 'red' : 'green',
            }"
          >
            <span> N/D </span>
            <i v-html="$icons.red_alert_sm"></i>
          </span>
        </div>
      </div>
    </div>

    <div :content="tooltip" v-tippy="{ arrow: true, theme: 'green' }">
      <p class="label_card text-center">Volume</p>
      <p
        class="text-ontick-steel-500 whitespace-nowrap text-center text-xs font-semibold dark:text-gray-400 sm:text-sm"
      >
        <template v-if="item.strategy_symbol === 'ANY'">
          <span
            v-if="item.volume_type === 'FIN_VOLUME'"
            :class="
              item.curr_positions.length
                ? 'font-bold text-gray-200'
                : 'text-gray-400'
            "
          >
            {{ !item.curr_positions.length ? "-/-" : multiSymbolVolume }}
          </span>
          <span
            v-else-if="item.volume_type === 'QUANTITY'"
            :class="
              item.curr_positions.length != 'Zerado'
                ? 'font-bold dark:text-gray-200'
                : 'text-gray-400'
            "
          >
            {{ !item.curr_positions.length ? "-" : multiSymbolVolume }}/{{
              item.param_volume
            }}
          </span>
        </template>
        <template v-else-if="item.strategy_market === 'Equities'">
          <span
            v-if="item.volume_type === 'FIN_VOLUME'"
            :class="
              item.position_status != 'Zerado'
                ? 'font-bold text-gray-200'
                : 'text-gray-400'
            "
          >
            {{
              item.position_status === "Zerado" ? "-/-" : item.position_volume
            }}
          </span>
          <span
            v-else-if="item.volume_type === 'QUANTITY'"
            :class="
              item.position_status != 'Zerado'
                ? 'font-bold dark:text-gray-200'
                : 'text-gray-400'
            "
          >
            {{
              item.position_status == "Zerado" ? "-" : item.position_volume
            }}/{{ item.param_volume }}
          </span>
        </template>
        <template v-else>
          <span
            :class="
              item.position_status != 'Zerado'
                ? 'text-ontick-steel-400 font-bold dark:text-gray-200'
                : 'text-ontick-steel-500 dark:text-gray-400'
            "
            >{{
              item.position_volume == 0 && item.position_status == "Zerado"
                ? "-"
                : item.position_volume
            }}
          </span>
          /
          <span>
            {{ item.param_volume }}
          </span>
        </template>
      </p>
    </div>

    <div>
      <div
        v-if="item.strategy_market === 'Equities'"
        :content="
          item.limit_type === 'PER_TRADE'
            ? 'Ganho por operação'
            : 'Ganho máximo diário'
        "
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        <p class="label_card text-right" v-if="item.limit_type === 'PER_TRADE'">
          Ganho/op.
        </p>
        <p
          class="label_card text-right"
          v-else-if="item.limit_type === 'DAILY'"
        >
          Ganho máx.
        </p>
        <p
          class="text-ontick-green-700 dark:text-ontick-green-500 text-right text-xs font-medium sm:text-sm"
        >
          <span> {{ item.max_gain | currency }}</span>
        </p>
      </div>
      <div
        v-else
        content="Ganho máximo diário"
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        <p class="label_card text-right">Ganho máx.</p>
        <p
          class="text-ontick-green-700 dark:text-ontick-green-500 text-right text-xs font-medium sm:text-sm"
        >
          <span v-if="item.max_daily_gain != 0">
            {{ item.max_daily_gain | currency }}
          </span>
          <span v-else class="flex items-center justify-end space-x-2">
            <span> N/D </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },

  computed: {
    maxLoss() {
      return this.item.strategy_market === "Equities"
        ? this.item.max_loss * -1
        : this.item.max_daily_loss;
    },
    maxGain() {
      return this.item.strategy_market === "Equities"
        ? this.item.max_gain
        : this.item.max_daily_gain;
    },
    tooltip() {
      if (this.item.strategy_market === "Equities") {
        const types = {
          FIN_VOLUME: `Quantidade a ser definida na abertura da posição (R$${this.item.curr_volume})`,
          QUANTITY: "Quantidade de ações (posicionados/parametrizados)",
        };
        return types[this.item.volume_type];
      } else {
        return "Volume (posicionados/parametrizados)";
      }
    },
    multiSymbolVolume() {
      if (this.item.curr_positions) {
        return this.item.curr_positions.reduce((acc, curr) => {
          return acc + (curr.position_volume || 0);
        }, 0);
      }
      return 0;
    },
  },

  watch: {
    // item: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     console.log("item", val);
    //     console.log("limit_type", val.limit_type);
    //     console.log("max_gain", val.max_gain);
    //     console.log("max_loss", val.max_loss);
    //   },
    // },
    // maxGain(val) {
    //   console.log(val);
    // },
  },
};
</script>

<style lang="scss" scoped>
.label_card {
  @apply text-xs text-gray-500 dark:text-gray-400;
}
</style>
